import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class LoadingService {

  private subject = new Subject<boolean>();

  constructor() { }

  public getShown(): Observable<boolean> {
    return this.subject.asObservable();
  }

  public show() {
    this.subject.next(true);
  }

  public hide() {
    this.subject.next(false);
  }
}
